import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { CheckoutPage } from './checkout/CheckoutPage';
import { UpsellEmbed } from './checkout/UpsellEmbed';
import { SubscriptionActionPage } from './checkout/SubscriptionActionPage';
import { PreviewFrame } from './preview/PreviewFrame';
import { FeatureFlagsProvider } from './shared/feature-flags/FeatureFlagsProvider';
import './styles/global.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('root element não encontrado');
}

createRoot(rootElement).render(
  <StrictMode>
    <FeatureFlagsProvider>
      <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
        <Routes>
          <Route path="/c/:checkoutId" element={<CheckoutPage />} />
          <Route path="/assinaturas/acao" element={<SubscriptionActionPage />} />
          <Route path="/u" element={<UpsellEmbed />} />
          <Route path="/f" element={<UpsellEmbed standalone />} />
          <Route path="/preview" element={<PreviewFrame />} />
          <Route path="/" element={<Navigate to="/c/demo" replace />} />
          <Route path="*" element={<Navigate to="/c/demo" replace />} />
        </Routes>
      </BrowserRouter>
    </FeatureFlagsProvider>
  </StrictMode>,
);
